var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  viewBox: "0 0 36 36",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_197_776",
  style: {
    "maskType": "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 6,
  y: 6,
  width: 24,
  height: 24
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 6,
  width: 24,
  height: 24,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_197_776)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 24V22H20V24H16ZM12 19V17H24V19H12ZM9 14V12H27V14H9Z",
  fill: "#47484C"
}))));
export default __webpack_public_path__ + "teg/media/filter-new.9a0f50f4.svg";
export { SvgComponent as ReactComponent };